import type { ProcessingRequest } from "../api/types";

export function mopMetadata(request: ProcessingRequest): Record<string, unknown> {
  const metadata = request.extraction?.metadata as Record<string, unknown> | undefined;
  return (metadata?.mop as Record<string, unknown> | undefined) ?? {};
}

export function isMopRequest(request: ProcessingRequest): boolean {
  const metadata = request.extraction?.metadata as Record<string, unknown> | undefined;
  const mop = mopMetadata(request);
  return request.channel === "email" && (
    request.classification?.flow_type === "mop" || metadata?.request_family === "mop" ||
    (mop.regex_eligible === true && (mop.intent_verified === true || mop.verification_pending === true))
  );
}
